import { render, staticRenderFns } from "./HuaYinPage.vue?vue&type=template&id=921573c0&scoped=true&"
import script from "./HuaYinPage.vue?vue&type=script&lang=js&"
export * from "./HuaYinPage.vue?vue&type=script&lang=js&"
import style0 from "./HuaYinPage.vue?vue&type=style&index=0&id=921573c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921573c0",
  null
  
)

export default component.exports